import * as FIELDNAMES from '/01_fundaments/utilities/fieldNames';


/*=============================================
= START - Error messages
=============================================*/

// Used when SAP Customer Data Cloud returns an error code.
// Each error code has definitions for the field errors to show,
// and the notification to show to the user.
// the error messages are also exposed via /.well-known/config/{clientId}

export const errorMessages = {

	// Internal error messages:

	// ACM General error
	900: {
		errors: {},
		notification: 'Er ging iets mis tijdens het bevestigen via \'Mijn Burgerprofiel\'. Probeer het later opnieuw.'
	},

	// SAP Customer Data Cloud error messages:

	// User canceled during the login process.
	200001: {
		errors: {},
		notification: 'Je hebt het loginproces onderbroken'
	},

	// Account pending registration
	206001: {
		errors: {},
		notification: 'Je hebt het registratieproces nog niet voltooid.'
	},

	// Account pending verification
	206002: {
		errors: {
			[FIELDNAMES.EMAIL]: 'Controleer je e-mailadres'
		},
		notification: 'Je moet nog verifiëren dat je eigenaar bent van dit e-mailadres. Kijk in je inbox voor onze verificatie e-mail.'
	},

	// Social login - Auth code reuse
	400014: {
		errors: {},
		notification: 'Het aanmelden met je sociale media-account is niet gelukt.'
	},

	// Email not verified
	400028: {
		errors: {},
		notification: 'Dit e-mail adres is nog niet geverifieerd.'
	},

	// Old password used to login
	401030: {
		errors: {
			[FIELDNAMES.PASSWORD]: 'Controleer je wachtwoord'
		},
		notification: 'Je hebt onlangs een nieuw wachtwoord aangemaakt en tracht in te loggen met het oude.'
	},

	// Request has expired
	403002: {
		errors: {},
		notification: 'Deze link is verlopen. Vraag een nieuwe aan.'
	},

	// Reset password link invalid
	403025: {
		errors: {},
		notification: 'Deze link is niet geldig. Reset je wachtwoord opnieuw om een nieuwe link te ontvangen.'
	},

	// Account disabled
	403041: {
		errors: {},
		notification: 'Je account is in verwijdering'
	},

	// Invalid LoginID
	403042: {
		errors: {
			[FIELDNAMES.EMAIL]: 'Controleer je e-mailadres',
			[FIELDNAMES.PASSWORD]: 'Controleer je wachtwoord',
			[FIELDNAMES.PASSWORD_CREATION]: 'Controleer je wachtwoord'
		},
		notification: 'Controleer je login gegevens op fouten.'
	},

	// LoginID already exists
	403043: {
		errors: {},
		notification: 'Je hebt reeds een account. Meld je aan.'
	},

	// Under age of 13 years
	403044: {
		errors: {
			[FIELDNAMES.BIRTHDATE]: 'Je moet minstens 13 jaar oud zijn',
		},
		notification: 'Onder een leeftijd van 13 jaar kan je geen gebruik maken van het vrt-profiel'
	},

	// Password reset e-mail not found
	403047: {
		errors: {},
		notification: 'Er is geen registratie met dit e-mailadres.'
	},

	// Password change request is pending
	403100: {
		errors: {
			[FIELDNAMES.PASSWORD]: 'Controleer je wachtwoord',
			[FIELDNAMES.PASSWORD_CREATION]: 'Controleer je wachtwoord'
		},
		notification: 'Je hebt onlangs een nieuw wachtwoord aangevraagd, maar deze nog niet aangepast.'
	},

	// Account Temporarily Locked Out
	403120: {
		errors: {
			[FIELDNAMES.EMAIL]: 'Controleer je e-mailadres',
			[FIELDNAMES.PASSWORD]: 'Controleer je wachtwoord',
			[FIELDNAMES.PASSWORD_CREATION]: 'Controleer je wachtwoord'
		},
		notification: 'Je hebt te vaak proberen inloggen met onjuiste gegevens. Probeer het later nogmaals.'
	},

	// Social login - General error from the provider.
	500023: {
		errors: {},
		notification: 'Het aanmelden met je sociale media-account is niet gelukt.'
	}

};

/*=============================================
= END - Error messages
=============================================*/
